import { useStore } from 'vuex';
import {
  KeepAlive, computed, defineComponent, ref, watch, Transition,
} from 'vue';
import config from '@/config';

export default defineComponent({
  setup() {
    const { getters } = useStore();
    const routerKey = computed(() => getters.currentDate);
    const useKeepAlive = computed(() => getters.useKeepAlive);
    const cachedViews = computed(() => getters.cachedViews);

    const keepAliveInclude = ref(['']);
    watch(
      cachedViews,
      (newCachedViews) => {
        keepAliveInclude.value = [...config.multipleNav.fixedViews, ...newCachedViews];
      },
      {
        deep: true,
      }
    );

    return () => (
      <router-view key={routerKey.value}>
        {
          ({ Component }: { Component: any }) => (
            <Transition
              mode="out-in"
              name="router-view__fade"
            >
              {
                useKeepAlive.value
                  ? <KeepAlive include={keepAliveInclude.value}>
                    <Component />
                  </KeepAlive>
                  : <Component />
              }
            </Transition>
          )
        }
      </router-view>
    );
  },
});
